import { createAsyncThunk } from '@reduxjs/toolkit';

import { IBaseUser, IUser } from '.';
import { AdminApiPaths } from '../../dataProvider/APIPaths';
import APIDataProvider from '../../dataProvider/APIDataProvider';
import ApiDataProviderV2, {
  TApiPaginationResponse,
  TApiResponse,
} from '../../api/ApiDataProvider';
import { AdminApiPaths as AdminApiPathsV2 } from '../../api/APIPaths';

export type TGetUserListByNameAsAdmin = {
  offset: number;
  limit: number;
  name?: string;
  country?: string;
  level?: string;
};

const UsersApiDataProvider = new APIDataProvider<IUser>();

const apiDataProviderV2 = new ApiDataProviderV2();

export const adminGetUserById = createAsyncThunk(
  '/admin/users/id',
  async (id: string) => {
    const path = `${AdminApiPaths.users}/${id}`;

    const response = await UsersApiDataProvider.getById(path);

    return response.data;
  }
);

// V2
export const getUserListForDropDownAsAdmin = createAsyncThunk(
  '/admin/users/list-for-dropdown',
  async ({
    limit,
    offset,
    name,
    country,
    level,
  }: TGetUserListByNameAsAdmin) => {
    let path = `${AdminApiPathsV2.users}?limit=${limit}&offset=${offset}`;

    if (name) {
      path += `&name=${name}`;
    }
    if (country) {
      path += `&country=${country}`;
    }
    if (level) {
      path += `&level=${level}`;
    }

    const response = await apiDataProviderV2.get<
      TApiResponse<TApiPaginationResponse<IBaseUser>>
    >(path);

    return response.data;
  }
);

export default adminGetUserById;
